// extracted by css-extract-rspack-plugin
export default {"root":"NbwcMx","animator":"sNIoZ0","notification-link":"UPBsn5","notificationLink":"UPBsn5"};